import { COLORS } from '../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => {
  // take mobile-first approach to do the styling

  const minSm = theme.breakpoints.up('sm');

  return {
    root: {
      display: 'flex',
      backgroundColor: COLORS.GREY_DARK,
      flexDirection: 'column',
      alignItems: 'baseline',
      padding: '20px 0',
      height: '100%',
    },
    sidebarItem: {
      width: '100%',
    },
    navLogo: {
      marginLeft: 10,
      marginBottom: 10,
      [minSm]: {
        display: 'none',
      },
    },
    sidebarItemLabel: {
      display: 'block',
      marginRight: 'auto',
    },
    button: {
      fontWeight: 'normal',
      textTransform: 'none',
    },
    navLink: {
      textDecoration: 'none',
      width: '100%',
    },
    activeLink: {
      '& > div': {
        borderLeft: `4px solid ${COLORS.GREEN_LIGHT}`,
        backgroundColor: COLORS.GREY_DARKER,
      },
    },
    leftIcon: {
      marginRight: 10,
    },
    divider: {
      display: 'block',
      backgroundColor: COLORS.GREY_LIGHT,
      margin: '10px 20px',
      width: 'calc(100% - 40px)',
    },
  };
};

export default styles;
